import _ from 'underscore';
import moment from 'moment';

function PerformanceTallyCtrl($scope, $stateParams, $timeout, $location, $q, venueService, sdkUtils, eventService, attributionSourceService, tallyAggregateService, pubsubService, modalService, permissionService, organizationService, managementUserOrganizationMemberService, alertService, utilsService, dateUtilsService) { //eslint-disable-line
  const ALL_VENUES_ID = 'ALL_VENUES_ID';
  const ALL_ATTRIBUTION_ID = 'ALL_ATTRIBUTION_ID';
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.loading = true;
  let initialAttributionLoad = true;

  function _initScope() {
    $scope.viewTypes = [{
      key: 'Tallys By User',
      value: 'TALLYS_BY_USER'
    }];
    $scope.currentViewType = $scope.viewTypes[0].value;

    //enums
    $scope.range = n => new Array(Math.max(n, 0) || 0);

    $scope.filterUsersForm = {
      venue: null,
      attributionSource: null
    };

    $scope.tallysByUserDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50,
      columnDefs: [{
        visible: true,
        targets: 0
      }],
      order: [
        [0, 'asc']
      ]
    };

    $scope.$watchGroup(['filterUsersForm.venue', 'filterUsersForm.attributionSource'], () => {
      if (initialAttributionLoad) return; //prevent this from firing before tally aggregates have been loaded the first time
      _refreshReport();
    });

    $scope.dateRangePicker = {
      options: {
        ranges: {
          'This Week': [moment().startOf('week'), moment().endOf('week')],
          'Last Week': [moment().day(-6), moment().day(0)],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Next 3 Months': [moment().startOf('month'), moment().add(62, 'day').endOf('month')],
          'Last 3 Months': [moment().subtract(62, 'day').endOf('month'), moment()]
        },
        locale: {
          format: 'ddd, MMM. Do YYYY'
        },
        linkedCalendars: false,
        alwaysShowCalendars: true,
        parentEl: '.date-range-wrapper',
        opens: 'left'
      }
    };

    $scope.$watch('dateRangePicker.date', () => {
      if (initialAttributionLoad) return;

      _refreshReport();
      syncLocationStartEnd();
    });

    /**
     * @desc Date range initial date
     */
    $scope.dateRangePicker.date = {
      startDate: $stateParams.start ? moment(parseInt($stateParams.start, 10)) : $scope.dateRangePicker.options.ranges['Last Week'][0].clone(),
      endDate: $stateParams.end ? moment(parseInt($stateParams.end, 10)) : $scope.dateRangePicker.options.ranges['Last Week'][1].clone()
    };

    syncLocationStartEnd();
  }

  function syncLocationStartEnd() {
    $location.search({
      start: $scope.dateRangePicker.date.startDate.format('x'),
      end: $scope.dateRangePicker.date.endDate.format('x')
    });
  }

  function _loadData() {
    return $q.all([
        _getVenues(),
        _getAttributionSources()
      ])
      .then(() => {
        initialAttributionLoad = false;
        $scope.loading = false;
      });
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: 'name, id'
      })
      .then(filterVenuesByPermission)
      .then(venues => {
        $scope.venues = venues;

        if (!$scope.venues.length) {
          $scope.noPermission = true;
          return;
        }

        $scope.venues.unshift({
          id: ALL_VENUES_ID,
          name: 'All Venues'
        });

        $scope.filterUsersForm.venue = $scope.venues[0];

        return venues; //eslint-disable-line
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function filterVenuesByPermission(venues) {
    const permissionPromises = venues.map(venue => permissionService.canReadPerformanceReports(venue.id));

    return $q.all(permissionPromises)
      .then(promises => promises.reduce((arr, permissionPromise, index) => {
        if (permissionPromise) return arr.concat(venues[index]);
        return arr;
      }, []));
  }

  function _getAttributionSources() {
    return attributionSourceService.listByOrganizationId(currentUserOrganization.id)
      .then(attributionSources => {
        $scope.attributionSources = [{
            id: ALL_ATTRIBUTION_ID,
            name: 'All Users'
          },
          ...attributionSources
        ];

        $scope.filterUsersForm.attributionSource = $scope.attributionSources[0];
      })
      .catch(error => alertService.error(sdkUtils.getErrorFromResponse(error)));
  }

  function _refreshReport() {
    $scope.loading = true;

    return _getTallyAggregate()
      .then(() => {
        $scope.loading = false;
      });
  }

  function _getTallyAggregate() {
    if (!$scope.filterUsersForm.venue) return $q.resolve([]);

    const query = {
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.dateRangePicker.date.startDate),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.dateRangePicker.date.endDate),
      venueId: getVenueIdFilter(),
      groupBy: [
        'attributionName',
        'pricePerGuest',
        'date',
        'inventoryName',
        'venueName'
      ]
    };

    // specific attribution
    const attributionId = getAttributionSourceFilter();
    if (attributionId !== ALL_ATTRIBUTION_ID) query.attributionId = $scope.filterUsersForm.attributionSource.id;

    return tallyAggregateService.list(query)
      .then(generateTallysByUser)
      .catch(error => alertService.error(sdkUtils.getErrorFromResponse(error)));
  }

  // ll the heavy lifting
  function generateTallysByUser(tallyAggregates) {
    const inventoryUniqueIdToDataMap = new Map();
    const attributionNameToInventoryUniqueIdStatsMap = new Map();
    const attributionNameToTotalStatsMap = new Map();

    // cycle through the tally aggregates to generate cells for each attributionName - inventoryName/date combination
    tallyAggregates.forEach(tallyAggregate => {
      const date = new Date(tallyAggregate.date);
      const venueName = tallyAggregate.venueName;
      const inventoryName = tallyAggregate.inventoryName;
      const pricePerGuest = tallyAggregate.pricePerGuest;
      const attributionName = tallyAggregate.attributionName;
      const guestsCheckedInMale = tallyAggregate.guestsCheckedInMale;
      const guestsCheckedInFemale = tallyAggregate.guestsCheckedInFemale;
      const guestsCheckedInUnisex = tallyAggregate.guestsCheckedInUnisex;
      const guestsCheckedInTotal = guestsCheckedInMale + guestsCheckedInFemale + guestsCheckedInUnisex;
      const priceTotalMale = tallyAggregate.priceTotalMale;
      const priceTotalFemale = tallyAggregate.priceTotalFemale;
      const priceTotalUnisex = tallyAggregate.priceTotalUnisex;
      const priceTotal = priceTotalMale + priceTotalFemale + priceTotalUnisex;

      const inventoryUniqueId = `${venueName}-${date}-${inventoryName}-${pricePerGuest}`;

      const inventoryUniqueData = {
        date,
        pricePerGuest,
        inventoryName,
        venueName
      };
      inventoryUniqueIdToDataMap.set(inventoryUniqueId, inventoryUniqueData);

      // stats for individual inventory
      const inventoryUniqueIdStatsMap = attributionNameToInventoryUniqueIdStatsMap.get(attributionName) || new Map();
      const stats = new Map();
      stats.set('guestsCheckedInMale', guestsCheckedInMale);
      stats.set('guestsCheckedInFemale', guestsCheckedInFemale);
      stats.set('guestsCheckedInUnisex', guestsCheckedInUnisex);
      stats.set('priceTotalMale', priceTotalMale);
      stats.set('priceTotalFemale', priceTotalFemale);
      stats.set('priceTotalUnisex', priceTotalUnisex);

      // stats for total attribution
      const totalStatsObject = attributionNameToTotalStatsMap.get(attributionName) || {
        priceTotal: 0,
        guestsCheckedInTotal: 0
      };
      totalStatsObject.priceTotal += priceTotal;
      totalStatsObject.guestsCheckedInTotal += guestsCheckedInTotal;


      // put updated values back
      inventoryUniqueIdStatsMap.set(inventoryUniqueId, stats);
      attributionNameToInventoryUniqueIdStatsMap.set(attributionName, inventoryUniqueIdStatsMap);
      attributionNameToTotalStatsMap.set(attributionName, totalStatsObject);
    });

    const sortedInventoryUniqueIds = Array.from(inventoryUniqueIdToDataMap.keys()).sort((a, b) => {
      const inventoryUniqueDataA = inventoryUniqueIdToDataMap.get(a);
      const inventoryUniqueDataB = inventoryUniqueIdToDataMap.get(b);

      if (inventoryUniqueDataA.venueName < inventoryUniqueDataB.venueName) return -1;
      if (inventoryUniqueDataA.venueName > inventoryUniqueDataB.venueName) return 1;
      if (inventoryUniqueDataA.date.getTime() < inventoryUniqueDataB.date.getTime()) return -1;
      if (inventoryUniqueDataA.date.getTime() > inventoryUniqueDataB.date.getTime()) return 1;
      if (inventoryUniqueDataA.pricePerGuest < inventoryUniqueDataB.pricePerGuest) return -1;
      if (inventoryUniqueDataA.pricePerGuest > inventoryUniqueDataB.pricePerGuest) return 1;
      if (inventoryUniqueDataA.inventoryName < inventoryUniqueDataB.inventoryName) return -1;
      if (inventoryUniqueDataA.inventoryName > inventoryUniqueDataB.inventoryName) return 1;
      return 0;
    });

    // figure out the top venue-date header
    const initialVenueDateHeaderArray = sortedInventoryUniqueIds.length ? [{
      key: 'User Name'
    }] : [];

    $scope.venueDateHeader = sortedInventoryUniqueIds
      .reduce((arr, inventoryUniqueId) => {
        const inventoryUniqueIdData = inventoryUniqueIdToDataMap.get(inventoryUniqueId);
        const venueDateUniqueId = `${inventoryUniqueIdData.venueName} - ${moment(inventoryUniqueIdData.date).format('MM/DD')}`;

        const data = {
          key: venueDateUniqueId,
          colspan: 1
        };

        if (arr.length === 0) {
          arr = arr.concat(data);
        } else {
          const latest = arr[arr.length - 1];

          if (latest.key === venueDateUniqueId) {
            latest.colspan++; //eslint-disable-line
          } else {
            arr = arr.concat(data);
          }
        }

        return arr;
      }, initialVenueDateHeaderArray);

    // figure out the inventory-name header (must correspond to the venue-date header)
    $scope.inventoryNamePriceHeader = sortedInventoryUniqueIds
      .map(inventoryUniqueId => {
        const {
          inventoryName,
          pricePerGuest
        } = inventoryUniqueIdToDataMap.get(inventoryUniqueId);
        return `${inventoryName} ($${pricePerGuest})`;
      });

    // figure out the attributionName rows
    $scope.rows = Array.from(attributionNameToInventoryUniqueIdStatsMap.keys()).sort().reduce((arr, attributionName) => {
      const inventoryUniqueIdStatsMap = attributionNameToInventoryUniqueIdStatsMap.get(attributionName) || new Map();
      const totalStatsObject = attributionNameToTotalStatsMap.get(attributionName) || {};

      const row = [{
        name: attributionName,
        guestsCheckedInTotal: totalStatsObject.guestsCheckedInTotal || 0,
        priceTotal: totalStatsObject.priceTotal || 0
      }];

      sortedInventoryUniqueIds.forEach(inventoryUniqueId => {
        const inventoryUniqueIdStats = inventoryUniqueIdStatsMap.get(inventoryUniqueId) || new Map();

        row.push(
          `${inventoryUniqueIdStats.get('guestsCheckedInMale') || 0} / $${inventoryUniqueIdStats.get('priceTotalMale') || 0}`,
          `${inventoryUniqueIdStats.get('guestsCheckedInFemale') || 0} / $${inventoryUniqueIdStats.get('priceTotalFemale') || 0}`,
          `${inventoryUniqueIdStats.get('guestsCheckedInUnisex') || 0} / $${inventoryUniqueIdStats.get('priceTotalUnisex') || 0}`
        );
      });

      arr.push(row);
      return arr;
    }, []);
  }

  function getAttributionSourceFilter() {
    if ($scope.filterUsersForm.attributionSource && $scope.filterUsersForm.attributionSource.id !== ALL_ATTRIBUTION_ID) {
      return $scope.filterUsersForm.attributionSource.id;
    }

    return ALL_ATTRIBUTION_ID;
  }

  function getVenueIdFilter() {
    return $scope.filterUsersForm.venue.id === ALL_VENUES_ID ?
      _.pluck(_.filter($scope.venues, venue => venue.id !== ALL_VENUES_ID), 'id') :
      $scope.filterUsersForm.venue.id;
  }

  _initScope();

  _loadData();

}

PerformanceTallyCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$timeout',
  '$location',
  '$q',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.event',
  'jsSdk.attributionSource',
  'jsSdk.tallyAggregate',
  'pubsubService',
  'modalService',
  'permissionService',
  'organizationService',
  'managementUserOrganizationMemberService',
  'alertService',
  'utilsService',
  'dateUtilsService'
];

export default PerformanceTallyCtrl;



// WEBPACK FOOTER //
// ./src/components/performanceTally/performanceTallyCtrl.js